module.exports = __webpack_public_path__ + "img/addIconWhite.9b7ffb34.svg";